import { currentVisitorTimezoneSelector, updateSettings, userSelector } from '@lingoda/auth';
import { useRequestTracker } from '@lingoda/core';
import { handleFormSubmit } from '@lingoda/forms';
import { useDispatch, useSelector } from '@lingoda/hooks';
import { studentPreferencesSelector } from '@lingoda/students';
import { EditTimeZoneForm } from './EditTimeZoneForm';
import type { TimezoneFormValues } from './EditTimeZoneForm';

interface ChangeTimeZoneProps {
    onClose: () => void;
    goBack: () => void;
}

export const ChangeTimeZone = ({ onClose, goBack }: ChangeTimeZoneProps) => {
    const dispatch = useDispatch();
    const trackRequest = useRequestTracker();

    const user = useSelector(userSelector);
    const timezone = useSelector(currentVisitorTimezoneSelector);
    const preferences = useSelector(studentPreferencesSelector);
    const timeFormat = preferences?.timeFormat;
    const weekStart = preferences?.weekStart;

    const handleTimeZoneConfirm = handleFormSubmit(
        async (values: TimezoneFormValues) => {
            await trackRequest(
                dispatch(updateSettings(user?.id as number, user?.studentId as number, values)),
            );
        },
        undefined,
        goBack,
    );

    return (
        <EditTimeZoneForm
            timezone={timezone}
            timeFormat={timeFormat}
            weekStart={weekStart}
            onConfirm={handleTimeZoneConfirm}
            onClose={onClose}
            onBack={goBack}
        />
    );
};
